import { render, staticRenderFns } from "./BarrelList.vue?vue&type=template&id=74c84731&"
import script from "./BarrelList.vue?vue&type=script&lang=js&"
export * from "./BarrelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c84731')) {
      api.createRecord('74c84731', component.options)
    } else {
      api.reload('74c84731', component.options)
    }
    module.hot.accept("./BarrelList.vue?vue&type=template&id=74c84731&", function () {
      api.rerender('74c84731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/kiosk/barrels/BarrelList.vue"
export default component.exports